import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ContributingCommitteeItem {
  CommitteeId: string; // Adjust the type as needed
  canComment?: boolean;
  mustVote?: boolean;
  canVote?: boolean;
}
interface CreateNonStandardData {
  id: string;
  activeStep: number;
  contributingCommittee: ContributingCommitteeItem[];
}
const initialState: CreateNonStandardData = {
  id: "",
  activeStep: 0,
  contributingCommittee: [],
};

const recordNonStandardSlice = createSlice({
  name: "NonStandard",
  initialState,
  reducers: {
    setNonStandardRecordId: (state, action: PayloadAction<string>) => {
      state.id = action.payload; // Update the id in the state
    },
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload; // Update the id in the state
    },

    setContributionCommitteeId: (
      state,
      action: PayloadAction<ContributingCommitteeItem[]>
    ) => {
      state.contributingCommittee = action.payload; // Update the contributionCommitteeId
    },

    reset: () => initialState,
  },
});

export const {
  setNonStandardRecordId,
  setActiveStep,
  setContributionCommitteeId,
  reset,
} = recordNonStandardSlice.actions;
export default recordNonStandardSlice.reducer;
